// src/theme.ts
import { extendTheme } from "@chakra-ui/react";

const customTheme = extendTheme({
    initialColorMode: "light",
    useSystemColorMode: false,
    direction: "rtl", 
    styles: {
        global: {
        ".highlighted-note": {
            boxShadow: "0 0 0 3px var(--chakra-colors-red-400)",
            borderRadius: "var(--chakra-radii-lg)",
            transition: "box-shadow 0.3s ease-in-out",
        },
        },
    },
});

export default customTheme;